export default __webpack_public_path__ + "static/media/megaYacht.709cf15b.webp";